/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Magic_Link_GeneratedInputs */

const en_magic_link_generated = /** @type {(inputs: Magic_Link_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magic link generated successfully`)
};

const es_magic_link_generated = /** @type {(inputs: Magic_Link_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link magico generado correctamente`)
};

/**
* | output |
* | --- |
* | "Magic link generated successfully" |
*
* @param {Magic_Link_GeneratedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const magic_link_generated = /** @type {((inputs?: Magic_Link_GeneratedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Magic_Link_GeneratedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_magic_link_generated(inputs)
	return es_magic_link_generated(inputs)
});